/*
 * @Description: app Mutations
 */
import { MutationTree } from 'vuex'
import { UserState } from './state'
import { UserMutationTypes } from './mutation-types'
import { UserModel } from '@/model/userModel'

export type Mutations<S = UserState> = {
  [UserMutationTypes.SET_TOKEN](state: S, token: string): void
  [UserMutationTypes.SET_INFO](state: S, info: UserModel | null): void
  [UserMutationTypes.SET_ROLES](state: S, roles: string[]): void
  [UserMutationTypes.SET_MENU](state: S, menu: string[]): void
  [UserMutationTypes.SET_PERMISSION](state: S, permission: string[]): void
}

export const mutations: MutationTree<UserState> & Mutations = {
  [UserMutationTypes.SET_TOKEN](state: UserState, token: string) {
    state.token = token
  },

  [UserMutationTypes.SET_INFO](state: UserState, info: UserModel | null) {
    if (info == null) {
      state.info = null
    } else {
      state.info = Object.assign({}, info)
    }
  },

  [UserMutationTypes.SET_ROLES](state: UserState, roles: string[]) {
    state.roles = roles
  },

  [UserMutationTypes.SET_MENU](state: UserState, menu: string[]) {
    state.menu = menu
  },

  [UserMutationTypes.SET_PERMISSION](state: UserState, permission: string[]) {
    state.permission = permission
  }

}
